import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component'; 
import { KvkkComponent } from './kvkk/kvkk.component'; 
import { ApplyRegulationComponent } from './apply-regulation/apply-regulation.component';
import { ApplyFormComponent } from './apply-form/apply-form.component';
import { ApplyInfoComponent } from './apply-info/apply-info.component'; 
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ApplyResultComponent } from './apply-result/apply-result.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; 
import { UploadComponent } from './upload/upload.component';
import { ReactiveFormsModule } from '@angular/forms';  
import { UiLayoutHeaderComponent } from './ui-layout-header/ui-layout-header.component';
import { UiHeaderLayoutMainComponent } from './ui-header-layout-main/ui-header-layout-main.component'; 


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent, 
    KvkkComponent, 
    ApplyRegulationComponent,
    ApplyFormComponent,
    ApplyInfoComponent,
    ApplyResultComponent, 
    UploadComponent,   
    UiLayoutHeaderComponent, UiHeaderLayoutMainComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule, 
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { 

}
